import authRequest from "../utils/authRequest";
import moment from "moment";


export const getAllPayouts = (
    page: number,
    pageSize: number = 10,
    type: any,
    searchTexts: any

): Promise<any> => {
    return new Promise((resolve, reject) => {
        authRequest({
            // url: "/api/v1/payout/details/1/10?is_live=",
            // url: "/api/v1/payout/details"+ "?is_live=" + "false",
            url: `/api/v1/payout/details?is_live=${type == "all" ? "all" : type == "live" ? true : false}&page=${searchTexts ? 1 : page}&per_page=${pageSize}&searchTexts=${searchTexts ? searchTexts : ""}`,

            method: "get",
            // params: params
        })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getPayoutsFilter = (
  page: any,
  pageSize: any = 50,
  type?: string,
  client?: any,
  gateway?: any,
  card_type?: any,
  payment_status?: any,
  timezone?: any,
  start_date?: any,
  searchTexts?: string,
  end_date?: any,



): Promise<any> => {
  return new Promise((resolve, reject) => {
    // const data = `${('?is_live=' + (type === "live" ? true : type === "test" ? false : "all"))}${client?.length > 0 ? ('&client-ids=' + client) : ""}${gateway?.length > 0 ? ('&gateway-id=' + gateway) : ""}${card_type?.length > 0 ? ('&card_type=' + card_type) : ""}${payment_status?.length > 0 ? ('&status=' + payment_status) : ""}${start_date ? ('&start-date=' + moment(start_date).format("YYYY-MM-DD")) : ""}${end_date ? ('&end-date=' + moment(end_date).format("YYYY-MM-DD")) : ""}${timezone ? ('&timezone=' + timezone) : ""}${searchTexts ? ('&search_term=' + searchTexts) : ""}`
    const data = `${('?is_live=' + (type === "live" ? true : type === "test" ? false : "all"))}` +
      `${client?.length > 0 ? ('&client-ids=' + client) : ""}` +
      `${gateway?.length > 0 ? ('&gateway-id=' + gateway) : ""}` +
      `${payment_status?.length > 0 ? ('&status=' + payment_status) : ""}` +
      `${start_date ? ('&start-date=' + moment(start_date).format("YYYY-MM-DD")) : ""}` +
      `${end_date ? ('&end-date=' + moment(end_date).format("YYYY-MM-DD")) : ""}` +
      `${timezone ? ('&timezone=' + timezone) : ""}` +
      `${searchTexts ? ('&search_term=' + searchTexts) : ""}` +
      `&page=${String(page)}` +
      `&per_page=${String(pageSize)}`;
    authRequest({
      // url: "/api/v1/payment/filter/" + page + "/" + pageSize + `${data}`,
      url: "/api/v1/payout/filter" + `${data}`,
      method: "get",
    })
    .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const getFiatPayoutsFilter = (
  page: any,
  pageSize: any = 50,
  searchTexts?: string,
  filter?: any
): Promise<any> => {
  return new Promise((resolve, reject) => {

    const clients = filter?.clients?.join(",") || "";
    const gateways = filter?.gateways?.join(",") || "";
    const status = filter?.status?.join(",") || "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";
    
    const data =
      `${searchTexts ? `&search_term=${searchTexts}` : ""}` +
      `&page=${String(page)}` +
      `&per_page=${String(pageSize)}` +
      `&clients=${clients}` +
      `&gateways=${gateways}` +
      `&status=${status}` +
      `&start_date=${start_date}` +
      `&end_date=${end_date}`; 

    authRequest({
      url: `/api/v1/payout/fiat/filter?${data}`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCryptoPayoutsFilter = (
  page: any,
  pageSize: any = 50,
  searchTexts?: string,
  filter?: any
): Promise<any> => {
  return new Promise((resolve, reject) => {

    const clients = filter?.clients?.join(",") || "";
    const gateways = filter?.gateways?.join(",") || "";
    const status = filter?.status?.join(",") || "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";

    const data =
      `${searchTexts ? `&search_term=${searchTexts}` : ""}` +
      `&page=${String(page)}` +
      `&per_page=${String(pageSize)}` +
      `&clients=${clients}` +
      `&gateways=${gateways}` +
      `&status=${status}` +
      `&start_date=${start_date}` +
      `&end_date=${end_date}`; 

    authRequest({
      url: `/api/v1/payout/crypto/filter?${data}`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



export const DownloadCSV = (
  type?: string,
  client?: any,
  gateway?: any,
  payment_status?: any,
  start_date?: any,
  end_date?: any,
  searchTexts?: any
): Promise<any> => {
  return new Promise((resolve, reject) => {
    // const data = `${('?is_live=' + (type === "live" ? true : type === "test" ? false : "all"))}${client?.length > 0 ? ('&client-ids=' + client) : ""}${gateway?.length > 0 ? ('&gateway-id=' + gateway) : ""}${payment_status?.length > 0 ? ('&status=' + payment_status) : ""}${start_date ? ('&start-date=' + moment(start_date).format("YYYY-MM-DD")) : ""}${end_date ? ('&end-date=' + moment(end_date).format("YYYY-MM-DD")) : ""}`
    const data =
          `${'?is_live=' + (type === "live" ? true : type === "test" ? false : "all")}` +
          `${client?.length > 0 ? ('&client-ids=' + client) : ""}` +
          `${gateway?.length > 0 ? ('&gateway-id=' + gateway) : ""}` +
          `${payment_status?.length > 0 ? ('&status=' + payment_status) : ""}` +
          `${start_date ? ('&start-date=' + moment(start_date).format("YYYY-MM-DD")) : ""}` +
          `${end_date ? ('&end-date=' + moment(end_date).format("YYYY-MM-DD")) : ""}` +
          `${searchTexts ? ('&search_term=' + encodeURIComponent(searchTexts)) : ""}`;
    authRequest({
      url: "/api/v1/payout/download-csv" + `${data}`,
      method: "get",
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


